const escapeMap = {
  '&': '&amp;',
  '"': '&quot;',
  '<': '&lt;',
  '>': '&gt;',
  "'": '&#39;',
} as const satisfies Record<string, string>;

const escape = (str: string) => str.replaceAll(/[&"<>']/g, (char) => escapeMap[char as keyof typeof escapeMap]);

export const linkify = (str: string) =>
  str.replaceAll(/(https:\/\/[^\s&/:<>]+(?::\d+)?(?:\/[^\s"#&'()<>]*(?:#[^\s"&'()<>]+)?)?)|(.)/gi, (_all, url, normal) => {
    if (url) {
      if (/^https:\/\/(www.)?iichi.com/.test(url)) {
        const safeUrl = escape(url);
        return `<a href="${safeUrl}">${safeUrl}</a>`;
      }
      return url;
    }
    return normal;
  });
